import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Empty, Chip } from "../components/ui-bits";
import { Activity, User as UserIcon } from "lucide-react";

const ACTION_LABELS = {
  brand_switch: { label: "Brand switch", tone: "default" },
  brand_exit: { label: "Exit workspace", tone: "default" },
  admin_impersonate: { label: "Admin impersonate", tone: "gold" },
  brand_duplicate: { label: "Brand duplicated", tone: "green" },
  order_paid: { label: "Order paid", tone: "green" },
};

export default function AuditLogsPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-logs").then(r => setLogs(r.data)).finally(() => setLoading(false));
  }, []);

  const when = (iso) => {
    if (!iso) return "—";
    try { return new Date(iso).toLocaleString(); } catch { return iso; }
  };

  return (
    <div data-testid="audit-logs-page">
      <PageHeader
        eyebrow="Security"
        title="Audit Log"
        description="Every brand switch, admin impersonation, duplication and payment event — filed for compliance."
      />
      {loading ? <div className="text-[#737373]">Loading…</div> : logs.length === 0 ? <Empty title="No audit events yet"/> : (
        <div className="card-dark">
          <table className="tbl" data-testid="audit-table">
            <thead><tr><th>When</th><th>Action</th><th>User</th><th>Details</th></tr></thead>
            <tbody>
              {logs.map(l => {
                const meta = ACTION_LABELS[l.action] || { label: l.action, tone: "default" };
                return (
                  <tr key={l.id} data-testid={`audit-row-${l.id}`}>
                    <td className="text-[#525252] text-xs whitespace-nowrap">{when(l.at)}</td>
                    <td><Chip tone={meta.tone}>{meta.label}</Chip></td>
                    <td className="text-xs">
                      {l.user ? (
                        <div>
                          <div className="text-[#0A0A0A]">{l.user.name}</div>
                          <div className="text-[#737373]">{l.user.email}</div>
                        </div>
                      ) : <span className="text-[#737373]">—</span>}
                    </td>
                    <td className="text-xs text-[#525252]">
                      {l.brand_id && <div>Brand: <span className="text-[#0A0A0A]">{l.brand_id.slice(0,8)}…</span></div>}
                      {l.order_id && <div>Order: {l.order_id.slice(0,8)}…</div>}
                      {l.source_brand_id && <div>From: {l.source_brand_id.slice(0,8)}…</div>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
